import React from 'react';
import { ImportantBenefitTypes } from './ImportantBenefitsTypes';
import {
  Columns,
  Column,
  Image,
  Container,
} from '@codeparva/ui-components-library';
import TextSection from './TextSection';

const defaultCustomArt: ImportantBenefitTypes.TCustomArt = {
  show: false,
  position: 'left',
  imageUrl: '',
};

export const ImportantBenefits = ({
  customArt = defaultCustomArt,
  description,
  title,
  callToAction,
  className,
  showImportantBenefits,
  theme = 'light',
}: ImportantBenefitTypes.IImportantBenefits) => {
  const { show, position, imageUrl } = customArt;

  const textColor = theme === 'light' ? 'primary' : 'secondary';
  const sectionBackgroundColor = theme === 'light' ? 'secondary' : 'primary';

  const ArtSection = () => (
    <Column size={3} className="artSection">
      <Image src={imageUrl} />
    </Column>
  );

  const LeftCustomArtSection = () => {
    return (
      <Columns className="is-width-100 m-0">
        {show && <ArtSection />}
        <Column
          mobile={{ size: 12 }}
          tablet={{ size: show ? 9 : 12 }}
          className="is-flex is-justify-content-center is-flex-direction-column"
        >
          <TextSection
            description={description}
            title={title}
            callToAction={callToAction}
            textColor={textColor}
            theme={theme}
          />
        </Column>
      </Columns>
    );
  };
  const RightCustomArtSection = () => {
    return (
      <Columns className="is-width-100 m-0">
        <Column
          mobile={{ size: 12 }}
          tablet={{ size: show ? 9 : 12 }}
          className="is-flex is-justify-content-center is-flex-direction-column"
        >
          <TextSection
            description={description}
            title={title}
            callToAction={callToAction}
            textColor={textColor}
            theme={theme}
          />
        </Column>
        {show && <ArtSection />}
      </Columns>
    );
  };
  return showImportantBenefits ? (
    <div
      className={
        className
          ? `importantBenefits has-background-${sectionBackgroundColor} ${className}`
          : `importantBenefits has-background-${sectionBackgroundColor}`
      }
    >
      <div className={`importantBenefitsContainer`}>
        <Container className="my-0 py-4">
          {position === 'right' ? (
            <RightCustomArtSection />
          ) : (
            <LeftCustomArtSection />
          )}
        </Container>
      </div>
    </div>
  ) : (
    <></>
  );
};
